import {
  CREATE_APP_ROLE,
  GET_APP_ROLES,
  GET_CHECK_ROLE,
  GET_ROLE,
  REMOVE_APP_ROLE,
  SET_APP_ROLES,
  SET_CHECK_ROLE,
  SET_CREATE_APP_ROLE,
  SET_IS_CHECK,
  SET_IS_CHECK_ROLE,
  SET_REMOVE_APP_ROLE,
  SET_ROLE,
  SET_UPDATE_APP_ROLE,
  UPDATE_APP_ROLE,
} from "./types";

export const getAppRoles = (rolesData: any) => {
  return {
    type: GET_APP_ROLES,
    payload: rolesData,
  };
};

export const setAppRoles = (payload: any) => {
  return {
    type: SET_APP_ROLES,
    payload,
  };
};

export const removeAppRole = (payload: any) => {
  return {
    type: REMOVE_APP_ROLE,
    payload,
  };
};

export const setRemoveAppRole = (payload: any) => {
  return {
    type: SET_REMOVE_APP_ROLE,
    payload,
  };
};

export const getRole = (roleId: any) => {
  return {
    type: GET_ROLE,
    payload: roleId,
  };
};

export const setRole = (payload: any) => {
  return {
    type: SET_ROLE,
    payload,
  };
};

export const createAppRole = (payload: any) => {
  return {
    type: CREATE_APP_ROLE,
    payload,
  };
};
export const setCreateAppRole = (roleResponse: any) => {
  return {
    type: SET_CREATE_APP_ROLE,
    payload: roleResponse,
  };
};

export const updateAppRole = (payload: any) => {
  return {
    type: UPDATE_APP_ROLE,
    payload,
  };
};

export const setUpdatedAppRole = (roleResponse: any) => {
  return {
    type: SET_UPDATE_APP_ROLE,
    payload: roleResponse,
  };
};

export const getCheckRole = (val: any) => {
  return {
    type: GET_CHECK_ROLE,
    payload: val,
  };
};

export const setCheckRole = (checkRole: any) => {
  return {
    type: SET_CHECK_ROLE,
    payload: checkRole,
  };
};
export const setIsCheckRole = (value: boolean) => {
  return {
    type: SET_IS_CHECK_ROLE,
    value,
  };
};

export const setIsCheck = (value: any) => {
  return {
    type: SET_IS_CHECK,
    value,
  };
};